import { API, authClient } from "../index";

/**
 * Get error logs with optional filters.
 * @param {{ dateFrom?: string, dateTo?: string, process?: string }} params - dateFrom/dateTo as ISO or YYYY-MM-DD
 */
export const getErrorLogs = (params = {}) => {
  const searchParams = new URLSearchParams();
  if (params.dateFrom) searchParams.set("dateFrom", params.dateFrom);
  if (params.dateTo) searchParams.set("dateTo", params.dateTo);
  if (params.process) searchParams.set("process", params.process);
  const query = searchParams.toString();
  return authClient().get(`${API}/errorLog${query ? `?${query}` : ""}`);
};
